import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import * as React from 'react';
// @mui
import {  
          Container, 
          Stack,
          Button,
          Checkbox,
          Avatar

} from '@mui/material';
// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { UserListToolbar } from '../sections/@dashboard/user';

import Iconify from '../components/iconify';

import AddUsuario from './AddUsuario';

// api
import { getUsuariosInativos, updateUsuario } from './api';

// ----------------------------

const emptyData = {
  nome : '',
  email: '',
  telefone: '',
  password: null,
  confirmpassword: null,
  primeirologin: true,
  supervisor: true,
  ativo: true,
  foto: null
}

// ----------------------------------------------------------------------

export default function Usuarios() {
  // Kits
  const [usuarios, setUsuarios] = useState([])

  useEffect(() => { fetchUsuarios() }, []);
  
  const fetchUsuarios = () => {
    getUsuariosInativos()
      .then((dados) => {
        setUsuarios(dados);
      })
      .catch((error) => {
        // Trate erros aqui
        window.alert("Erro ao consultar banco de dados")
        console.error('Erro ao buscar dados da API:', error);
      });
  }

  // Modal
  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState({...emptyData});
  const handleOpen = () => setOpen(true);
  
  const handleClose = () => {
    setOpen(false)
    setData(emptyData)
  };

  const onConfirmHandler = async (data) => {
    const result = await updateUsuario(data);
    if(result.ok){
      handleClose()
      fetchUsuarios();
    }
    window.alert(result.msg)
    
  };

  // Tabela
  const handleDoubleClickTable = (row, index) => {
    setData({...row, index})
    setOpen(true)
  }

  // Fitltro tabela
  const [filterValue, setFilterValue] = useState('');

  const filtered = usuarios.filter((row) =>{
    const filterValueLower = filterValue.toLowerCase();
    return (
      row.nome?.toLowerCase().includes(filterValueLower) ||
      row.telefone?.toLowerCase().includes(filterValueLower) ||
      row.email?.toLowerCase().includes(filterValueLower)
    );
  });

  const handleFilter = (event) => {
    setFilterValue(event.target.value);
  };


  // ----------------------

  return (
    <>
      <Helmet>
        <title> Usuários </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction={'row'} justifyContent={'space-between'}>
          <UserListToolbar filterName={filterValue} onFilterName={handleFilter} sx={{width: '100%'}}/>

          <Button variant="contained" startIcon={<Iconify icon="zondicons:add-solid" />} onClick={handleOpen}  sx={{height: 50, minWidth: 100}}>
            Adicionar
          </Button>
        </Stack>

        
        
        {/* ------------ Tabela de Usuarios ------------ */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Foto</TableCell>
                <TableCell align="left">Nome</TableCell>
                <TableCell align="center">Telefone</TableCell>
                <TableCell align="center">Email</TableCell>
                <TableCell align="center">Primeiro Login</TableCell>
                <TableCell align="center">Supervisor</TableCell>
                <TableCell align="center">Ativo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.map((row,index) => (
                <TableRow
                  key={index}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover':{backgroundColor:'Azure'} }}
                  onDoubleClick={() => handleDoubleClickTable(row,index)}
                >
                  <TableCell align="center">
                    <Avatar src={row.foto || undefined} sx={{ width: 36, height: 36, margin: '0 auto', fontSize: 16 }}>
                      {!row.foto && row.nome?.charAt(0).toUpperCase()}
                    </Avatar>
                  </TableCell>
                  <TableCell align="left" sx={{ whiteSpace: "nowrap" }}>{row.nome}</TableCell>
                  <TableCell align="center">{row.telefone}</TableCell>
                  <TableCell align="center">{row.email}</TableCell>
                  <TableCell align="center"><Checkbox id='primeirologin' disabled checked={row.primeirologin}/></TableCell>
                  <TableCell align="center"><Checkbox id='supervisor' disabled checked={row.supervisor}/></TableCell>
                  <TableCell align="center"><Checkbox id='ativo' disabled checked={row.ativo}/></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        
        {/* Modal Add */}
        {open && <AddUsuario open={open} data={data} onClose={handleClose} onConfirm={onConfirmHandler} />}
        

      </Container>


    </>
  );
}